import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeEnum'
})
export class CapitalizeEnumPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;
    // Convert camelCase to separate words and capitalize
    return value
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, (str) => str.toUpperCase());
  }

}
